import { render, staticRenderFns } from "./x3-foot-btn.vue?vue&type=template&id=63bcfee6&scoped=true&"
import script from "./x3-foot-btn.vue?vue&type=script&lang=js&"
export * from "./x3-foot-btn.vue?vue&type=script&lang=js&"
import style0 from "./x3-foot-btn.vue?vue&type=style&index=0&id=63bcfee6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bcfee6",
  null
  
)

export default component.exports